import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
export class Loader {
    static css(importVO, rejectEnabled = true, utils) {
        return new Promise((resolve, reject) => {
            Loader._load('link', importVO, resolve, reject, rejectEnabled, utils);
        });
    }
    static js(importVO, rejectEnabled = true, utils) {
        return new Promise((resolve, reject) => {
            Loader._load('script', importVO, resolve, reject, rejectEnabled, utils);
        });
    }
    static _load(importTag, importVO, resolve, reject, rejectEnabled = true, utils) {
        const element = document.createElement(importTag);
        let sourceAttribute;
        let parent;
        switch (utils.Import.alreadyPresent(importVO.url, importVO.namespace)) {
            case true:
                resolve(importVO);
                break;
            case false:
                element.addEventListener('load', (event) => {
                    importVO.failed = false;
                    importVO.event = event;
                    resolve(importVO);
                });
                element.addEventListener('error', (event) => {
                    importVO.failed = true;
                    importVO.event = event;
                    switch (rejectEnabled) {
                        case true:
                            reject(importVO);
                            break;
                        case false:
                            resolve(importVO, 'failed');
                            break;
                    }
                });
                switch (importTag) {
                    case 'script':
                        parent = 'body';
                        sourceAttribute = 'src';
                        element.async = false;
                        break;
                    case 'link':
                        parent = 'head';
                        sourceAttribute = 'href';
                        element.type = 'text/css';
                        element.rel = 'stylesheet';
                        break;
                    default:
                        throw new Error('Unsupported tag.');
                }
                element[sourceAttribute] = importVO.url;
                if (typeof importVO?.attributes === TrueType.OBJECT) {
                    Object.keys(importVO.attributes).forEach((key) => {
                        element.setAttribute(key, importVO.attributes[key]);
                    });
                }
                document[parent].appendChild(element);
                break;
        }
    }
}
